import React, { FC } from 'react';
import { SlotState, ViewAs } from 'components/TutoringDateTimePicker/TutoringDateTimePicker.types';
import styled from 'styled-components';
import { colors } from 'styles/colors';

type TimeSlotItemWrapperProps = {
  color: string,
  background?: string,
  hoverBackground?: string,
  noPointer?: boolean,
  bold?: boolean,
};

const TimeSlotItemWrapper = styled.div<TimeSlotItemWrapperProps>`
  border-radius: 2px;
  background: ${({ background }) => background ? background : ''};
  color: ${({ color }) => color};
  cursor: ${({ noPointer }) => noPointer ? '' : 'pointer'};
  padding: 8px;
  margin: 3px 6px 3px 6px;
  font-weight: ${({ bold }) => bold ? '600' : ''};

  &:hover {
   background: ${({ hoverBackground }) => hoverBackground ? hoverBackground : ''};
  }
`;

type props = {
  slotState: SlotState,
  onClick: () => void,
  viewAs: ViewAs,
};

export const TimeSlotItem: FC<props> = ({ slotState, onClick, viewAs, children }) => {

  const renderTimeSlotItem = () => {
    switch (viewAs) {
      case ViewAs.ELITE_TUTOR:
        switch (slotState) {
          case SlotState.AVAILABLE:
            return (
              <TimeSlotItemWrapper
                background={colors.primary}
                color={colors.white}
                hoverBackground={colors.primary}
              >
                {children}
              </TimeSlotItemWrapper>
            );
          case SlotState.OPEN:
            return (
              <TimeSlotItemWrapper
                background={colors.gray12}
                color={colors.black}
                hoverBackground={colors.gray11}
              >
                {children}
              </TimeSlotItemWrapper>
            );
          case SlotState.UNAVAILABLE:
            return (
              <TimeSlotItemWrapper
                background={colors.darkGray}
                color={colors.white}
                hoverBackground={colors.darkGray}
                noPointer
              >
                {children}
              </TimeSlotItemWrapper>
            );
          case SlotState.BOOKED:
            return (
              <TimeSlotItemWrapper
                background={colors.blue}
                color={colors.black}
                hoverBackground={colors.blue}
                noPointer
              >
                {children}
              </TimeSlotItemWrapper>
            );
          default:
            return null;
        }
      case ViewAs.ELITE_TUTOR_BOOKING:
        switch (slotState) {
          case SlotState.AVAILABLE:
          case SlotState.OPEN:
            return (
              <TimeSlotItemWrapper
                background={colors.gray12}
                color={colors.black}
                hoverBackground={colors.gray11}
              >
                {children}
              </TimeSlotItemWrapper>
            );
          case SlotState.UNAVAILABLE:
            return (
              <TimeSlotItemWrapper
                background={colors.darkGray}
                color={colors.white}
                hoverBackground={colors.darkGray}
                noPointer
              >
                {children}
              </TimeSlotItemWrapper>
            );
          case SlotState.BOOKED:
            return (
              <TimeSlotItemWrapper
                background={colors.blue}
                color={colors.black}
                hoverBackground={colors.blue}
                noPointer
              >
                {children}
              </TimeSlotItemWrapper>
            );
          default:
            return null;
        }
      case ViewAs.ELITE_SEEKER:
      default:
        switch (slotState) {
          case SlotState.AVAILABLE:
            return (
              <TimeSlotItemWrapper
                background={colors.gray11}
                color={colors.black}
                hoverBackground={colors.gray11}
                bold
              >
                {children}
              </TimeSlotItemWrapper>
            );
          case SlotState.BOOKED:
            return (
              <TimeSlotItemWrapper
                background={colors.primary}
                color={colors.white}
                hoverBackground={colors.primary}
                bold
              >
                {children}
              </TimeSlotItemWrapper>
            );
          case SlotState.OPEN:
          case SlotState.UNAVAILABLE:
            return (
              <TimeSlotItemWrapper color={colors.gray11} noPointer>
                {children}
              </TimeSlotItemWrapper>
            );
          default:
            return null;
        }
    }
  };

  return (
    <div onClick={onClick}>
      {renderTimeSlotItem()}
    </div>
  );
};
